import { getBaseUrl } from '@databases/database-state';
import { type Context } from '@databases/types/redux';

import { type ContextAppState } from './actions';

export function getContext(state: ContextAppState): Context {
  if (!state.context.context) {
    throw new Error('Context is not initialized.');
  }
  return state.context.context;
}

export function selectCurrentSpaceKey(state: ContextAppState): string {
  return getContext(state).space.key;
}

/**
 * @deprecated Use {@link getBaseUrl} from '@databases/database-state' instead
 * @example
 * // Before
 * import { selectBaseUrl } from '@databases/utils/redux/context/selectors';
 *
 * // After
 * import { getBaseUrl } from '@databases/database-state';
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function selectBaseUrl(state: ContextAppState): string {
  return getBaseUrl();
}

export function selectCurrentUserId(state: ContextAppState): string | undefined {
  return getContext(state).userId;
}
